import { $api } from '#/api/client'

interface IOnboardingStatusResponse {
  onboardingCompleted: boolean
  isLoading: boolean
  isError: boolean
}

function isOnboardingStatusData(value: unknown): value is { onboardingCompleted?: boolean } {
  return typeof value === 'object' && value !== null && 'onboardingCompleted' in value
}

export const useOnboardingStatus = (): IOnboardingStatusResponse => {
  const { data, isLoading, isError } = $api.useQuery(
    'get',
    '/onboarding/status',
    {},
    {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: true,
      select: (response: unknown): boolean => {
        if (isOnboardingStatusData(response)) return response.onboardingCompleted ?? true

        return true
      },
    },
  )

  return {
    onboardingCompleted: data ?? true,
    isLoading,
    isError,
  }
}
